import api from '@/apis'

export default {
  state: {
    visibility: false,
    user_id: null,
    is_submit_btn_disable: false
  },
  mutations: {
    INIT_RESET_PASSWORD_DIALOG(state, payload) {
      state.visibility = true
      state.user_id = payload
    },
    RESET_RESET_PASSWORD_DIALOG(state) {
      state.visibility = false
      state.user_id = null
    },
    SET_RESET_PASSWORD_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    SET_RESET_PASSWORD_DIALOG_USER_ID(state, payload) {
      state.user_id = payload
    },
    SET_RESET_PASSWORD_DIALOG_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.is_submit_btn_disable = payload
    }
  },
  actions: {
    async resetPassword({ rootState, state, commit, dispatch }, { password, type }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Resetting Password...', loading: true })
        commit('SET_RESET_PASSWORD_DIALOG_IS_SUBMIT_BTN_DISABLE', true)

        let user_id = type === 'login' ? rootState.auth.user_id : state.user_id
        const response = await api.updateUser({ params: { password: password, user_id: user_id } })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          if (type === 'dialog') commit('RESET_RESET_PASSWORD_DIALOG')
          else if (type === 'login') {
            commit('SET_AUTH_POST_LOGIN_ACTION_REQUIRED', false)
            dispatch('routeToFirstPage')
          }
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_RESET_PASSWORD_DIALOG_IS_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
